<template>
  <div class="course-evaluate-list" v-if="introduction">
    <van-collapse v-model="activeEvaluateNames" accordion>
      <van-collapse-item name="1" ref="collapseItemRef">
        <template #title>
          <div class="title-container">
            <div class="evaluate-title">
              <span class="title">课程简介</span>
            </div>
          </div>
        </template>
        <div class="evaluate-content">
          <div class="triangle-left"></div>
          <div class="triangle-right"></div>
          <div class="content">
            <img :src="introduction" class="content-img" alt="">
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  name: 'CourseEvaluateList',
  props: {
    introduction: {
      type: String
    }
  },
  data () {
    return {
      activeEvaluateNames: '1',
    }
  },
  watch: {
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.course-evaluate-list {
  padding: 16px 12px 0;

  .title-container {
    display: flex;
    align-items: center;

    .evaluate-title {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;

      .title {
        font-size: 14px;
        font-weight: bold;
        color: #1f333f;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .tips {
        float: right;
        font-size: 11px;
        color: #6d6d6d;
      }
    }
  }

  .evaluate-content {
    position: relative;

    .triangle-left {
      position: absolute;
      left: -5px;
      width: 5px;
      height: 5px;
      background: #999999;
      background: linear-gradient(45deg,
          transparent,
          transparent 50%,
          #999 51%,
          #999 100%);
    }

    .triangle-right {
      position: absolute;
      right: -5px;
      width: 5px;
      height: 5px;
      background: linear-gradient(-45deg,
          transparent,
          transparent 50%,
          #999 51%,
          #999 100%);
    }
  }

  .content {
    padding: 15px;
    box-sizing: border-box;
    .content-img {
      width: 100%;
    }
  }

  .answer {
    padding: 0 18px;
    margin-bottom: 15px;
    box-sizing: border-box;

    .answer-title {
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin-bottom: 7px;
      font-weight: 400;
    }

    .start-block {
      display: flex;

      .score {
        color: #999;
        font-size: 14px;
        margin-left: 50px;
      }
    }

    /deep/ .van-radio--horizontal {
      width: 33%;
      margin-top: 5px;
    }

  }

  /deep/ .van-collapse-item__wrapper {
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0 0 5px 5px;
  }

  /deep/ .van-cell {
    line-height: normal;
    display: flex;
    align-items: center;
    height: 44px;
    background: #fff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  }

  /deep/ .van-collapse-item__title--expanded {
    overflow: auto;
    border-radius: 12px 12px 0 0;
  }

  /deep/ .van-collapse-item__content {
    margin: 0 5px;
    padding: 0;
    background: #fff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 0 0 5px 5px;
  }
}</style>



// WEBPACK FOOTER //
// src/views/course/components/CourseIntroduction.vue